import React, { useContext, useEffect, useState } from 'react'
import { Paper, Grid, TextField, Button, FormControlLabel, Checkbox, Typography, LinearProgress, Dialog, DialogTitle, DialogContentText, DialogContent, DialogActions, Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { green } from '@mui/material/colors'
import { AuthContext } from '../../contexts/Auth.context';
import { useHistory } from 'react-router-dom';


const useStyles = makeStyles((theme) => {
  return {
    margin: {
      margin: "40px",
    },
    padding: {
      padding: "10px",
    },
    container: {
      minHeight: '90vh',
    },
    buttonProgress: {
      color: green[500],
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
    },
  }
})

export const Login = () => {
  const classes = useStyles()
  const history = useHistory()
  const { authenticated, login, loading, error, piiaAgreement, piiaOnAgree, username : name } = useContext(AuthContext)
  const [username, setUsername] = React.useState('')
  const [password, setPassword] = React.useState('')
  const [errorMsg, setErrorMsg] = React.useState('')
  const [piiaModal, setPiiaModal] = useState(false)
  const [isBackdropOpen, setIsBackdropOpen] = useState(false)

  const handleKeyPress = (e) => {
    if (e.keyCode === 13 || e.which === 13) {
      isBackdropOpen || login()
    }
  }

  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
  const [agreed, setAgreed] = useState(false)
  useEffect(() => {
    if (authenticated) {
      if (piiaAgreement) {
        console.log('piia')
        // history.push('/live')
      } else {
        setPiiaModal(true)
      }
    }
  }, [authenticated, history, piiaAgreement, login])

  useEffect(() => {
    if (authenticated && piiaAgreement) {
        history.push('/live')
    }
  }, [piiaAgreement, authenticated])
  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
      className={classes.container}
    >
      <Dialog
        open={piiaModal}
        onClose={() => setPiiaModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"

      >
        <DialogTitle id="alert-dialog-title">
          {"PROPRIETARY INFORMATION AND INVENTIONS AGREEMENT"}
        </DialogTitle>
        <DialogContent >
          <DialogContentText >
            <Box sx={{ maxHeight: "350px", overflow: "scroll", border: "1px" }}>

              The following confirms and memorializes an agreement that QALY Inc., a Delaware corporation (the “Company”) and I ({name}) have had since the commencement of my employment (which term, for purposes of this agreement, shall be deemed to include any relationship of service to the Company that I may have had prior to actually becoming an employee) with the Company in any capacity and that is and has been a material part of the consideration for my employment by Company:
              <ul>
                <li>I have not entered into, and I agree I will not enter into, any agreement either written or oral in conflict with this Agreement or my employment with Company.  I will not violate any agreement with or rights of any third party or, except as expressly authorized by Company in writing hereafter, use or disclose my own or any third party’s confidential information or intellectual property when acting within the scope of my employment or otherwise on behalf of Company.  Further, I have not retained anything containing any confidential information of a prior employer or other third party, whether or not created by me.</li>
                <li>Company shall own all right, title and interest (including patent rights, copyrights, trade secret rights, mask work rights, sui generis database rights and all other intellectual property rights of any sort throughout the world) relating to any and all inventions (whether or not patentable), works of authorship, mask works, designs, know-how, ideas and information made or conceived or reduced to practice, in whole or in part, by me during the term of my employment with Company to and only to the fullest extent allowed by California Labor Code Section 2870 (which is attached as Appendix A) (collectively “Inventions”) and I will promptly disclose all Inventions to Company.  Without disclosing any third party confidential information, I will also disclose anything I believe is excluded by Section 2870 so that the Company can make an independent assessment.  I hereby make all assignments necessary to accomplish the foregoing.  I shall further assist Company, at Company’s expense, to further evidence, record and perfect such assignments, and to perfect, obtain, maintain, enforce, and defend any rights specified to be so owned or assigned.  I hereby irrevocably designate and appoint Company as my agent and attorney-in-fact, coupled with an interest and with full power of substitution, to act for and in my behalf to execute and file any document and to do all other lawfully permitted acts to further the purposes of the foregoing with the same legal force and effect as if executed by me.  Without limiting paragraph 1 or Company’s other rights and remedies, if, when acting within the scope of my employment or otherwise on behalf of Company, I use or disclose my own or any third party’s confidential information or intellectual property (or if any Invention cannot be fully made, used, reproduced, distributed and otherwise exploited without using or violating the foregoing), Company will have and I hereby grant Company a perpetual, irrevocable, worldwide royalty-free, non-exclusive, sublicensable right and license to exploit and exercise all such confidential information and intellectual property rights. </li>
                <li>To the extent allowed by law, paragraph 2 includes all rights of paternity, integrity, disclosure and withdrawal and any other rights that may be known as or referred to as “moral rights,” “artist’s rights,” “droit moral,” or the like (collectively “Moral Rights”).  To the extent I retain any such Moral Rights under applicable law, I hereby ratify and consent to any action that may be taken with respect to such Moral Rights by or authorized by Company and agree not to assert any Moral Rights with respect thereto.  I will confirm any such ratifications, consents and agreements from time to time as requested by Company.   </li>
                <li>I agree that all Inventions and all other business, technical and financial information (including, without limitation, the identity of and information relating to customers or employees) I develop, learn or obtain during the term of my employment that relate to Company or the business or demonstrably anticipated business of Company or that are received by or for Company in confidence, constitute “Proprietary Information.”  I will hold in confidence and not disclose or, except within the scope of my employment, use any Proprietary Information.  However, I shall not be obligated under this paragraph with respect to information I can document is or becomes readily publicly available without restriction through no fault of mine.  Upon termination of my employment, I will promptly return to Company all items containing or embodying Proprietary Information (including all copies), except that I may keep my personal copies of (i) my compensation records, (ii) materials distributed to shareholders generally and (iii) this Agreement.  I also recognize and agree that I have no expectation of privacy with respect to Company’s telecommunications, networking or information processing systems (including, without limitation, stored computer files, email messages and voice messages) and that my activity and any files or messages on or using any of those systems may be monitored at any time without notice.  </li>
                <li>Until one year after the term of my employment, I will not encourage or solicit any employee or consultant of Company to leave Company for any reason (except for the bona fide firing of Company personnel within the scope of my employment).  </li>
                <li>I agree that during the term of my employment with Company (whether or not during business hours), I will not engage in any activity that is in any way competitive with the business or demonstrably anticipated business of Company, and I will not assist any other person or organization in competing or in preparing to compete with any business or demonstrably anticipated business of Company.    </li>
                <li>I agree that this Agreement is not an employment contract for any particular term and that I have the right to resign and Company has the right to terminate my employment at will, at any time, for any or no reason, with or without cause.  In addition, this Agreement does not purport to set forth all of the terms and conditions of my employment, and, as an employee of Company, I have obligations to Company which are not set forth in this Agreement.  However, the terms of this Agreement govern over any inconsistent terms and can only be changed by a subsequent written agreement signed by the President of Company.</li>
                <li>I agree that my obligations under paragraphs 2, 3, 4 and 5 of this Agreement shall continue in effect after termination of my employment, regardless of the reason or reasons for termination, and whether such termination is voluntary or involuntary on my part, and that Company is entitled to communicate my obligations under this Agreement to any future employer or potential employer of mine.  My obligations under paragraphs 2, 3 and 4 also shall be binding upon my heirs, executors, assigns, and administrators and shall inure to the benefit of Company, its subsidiaries, successors and assigns.  </li>
                <li>Any dispute in the meaning, effect or validity of this Agreement shall be resolved in accordance with the laws of the State of California without regard to the conflict of laws provisions thereof.  I further agree that if one or more provisions of this Agreement are held to be illegal or unenforceable under applicable California law, such illegal or unenforceable portion(s) shall be limited or excluded from this Agreement to the minimum extent required so that this Agreement shall otherwise remain in full force and effect and enforceable in accordance with its terms.  This Agreement is fully assignable and transferable by Company, but any purported assignment or transfer by me is void.  I also understand that any breach of this Agreement will cause irreparable harm to Company for which damages would not be an adequate remedy, and, therefore, Company will be entitled to injunctive relief with respect thereto in addition to any other remedies and without any requirement to post bond. </li>
                <br />
                <br />
                NOTICE: This agreement does not affect any immunity under 18 USC Sections 1833(b) (1) or (2), which read as follows (note that for purposes of this statute only, individuals performing work as contractors or consultants are considered to be employees):
                <br />
                <br />
                (1)  An individual shall not be held criminally or civilly liable under any Federal or State trade secret law for the disclosure of a trade secret that (A) is made (i) in confidence to a Federal, State, or local government official, either directly or indirectly, or to an attorney; and (ii) solely for the purpose of reporting or investigating a suspected violation of law; or (B) is made in a complaint or other document filed in a lawsuit or other proceeding, if such filing is made under seal.

                <br />
                <br />
                (2)  An individual who files a lawsuit for retaliation by an employer for reporting a suspected violation of law may disclose the trade secret to the attorney of the individual and use the trade secret information in the court proceeding, if the individual (A) files any document containing the trade secret under seal; and (B) does not disclose the trade secret, except pursuant to court order.
              </ul>
            </Box>


            <FormControlLabel
              control={<Checkbox color="primary" checked={agreed} onChange={e => setAgreed(e.target.checked)}/>}
              label={<p style={{ fontSize: "10px", color: "red", paddingTop: "10px" }}><strong>I HAVE READ THIS AGREEMENT CAREFULLY AND I UNDERSTAND AND ACCEPT THE OBLIGATIONS WHICH IT IMPOSES UPON ME WITHOUT RESERVATION.  NO PROMISES OR REPRESENTATIONS HAVE BEEN MADE TO ME TO INDUCE ME TO SIGN THIS AGREEMENT.  I SIGN THIS AGREEMENT VOLUNTARILY AND FREELY, IN DUPLICATE, WITH THE UNDERSTANDING THAT THE COMPANY WILL RETAIN ONE COUNTERPART AND THE OTHER COUNTERPART WILL BE RETAINED BY ME.
              </strong></p>}
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>

          <Button autoFocus disabled={!agreed} onClick={piiaOnAgree} >
            Agree
          </Button>
        </DialogActions>
      </Dialog>

      <Grid item  >
        {loading && <LinearProgress color="success" />}
        <Paper className={classes.padding}>

          <div className={classes.margin} >
            <Grid container justifyContent="center" spacing={2} alignItems="flex-end" >
              <Grid item align="center" md={true} sm={true} xs={true}>
                <Typography variant="h5">Sign in</Typography>
              </Grid>
            </Grid>
            <Grid container justifyContent="center" spacing={4} alignItems="flex-end">
              <Grid item align="center" md={true} sm={true} xs={true}>
                <Typography variant="subtitle1">
                  to continue to Quill
                </Typography>
              </Grid>
            </Grid>
            {error ? (
              <Grid
                container
                justifyContent="center"
                spacing={4}
                alignItems="flex-end"
              >
                <Grid item align="center" md={true} sm={true} xs={true}>
                  <Typography variant="body2" color="error">
                    * {error}
                  </Typography>
                </Grid>
              </Grid>
            ) : null}
            <Grid container spacing={4} alignItems="flex-end">
              <Grid item md={true} sm={true} xs={true}>
                <TextField
                  id="username"
                  label="Username"
                  type="email"
                  style={{ marginTop: "20px" }}
                  variant="outlined"
                  onChange={(e) => setUsername(e.target.value)}
                  onKeyPress={(e) => handleKeyPress(e)}
                  error={error}
                  fullWidth
                  autoFocus
                  required
                />
              </Grid>
            </Grid>
            <Grid container spacing={4} alignItems="flex-end">
              <Grid item md={true} sm={true} xs={true} style={{ marginTop: "20px" }}>
                <TextField
                  id="password"
                  label="Password"
                  type="password"
                  variant="outlined"
                  onChange={(e) => setPassword(e.target.value)}
                  onKeyPress={(e) => handleKeyPress(e)}
                  error={error}
                  fullWidth
                  required
                />
              </Grid>
            </Grid>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid item>
                <FormControlLabel
                  control={<Checkbox color="primary" />}
                  label="Remember me"
                />
              </Grid>
              <Grid item>
                <Button
                  disableFocusRipple
                  disableRipple
                  style={{ textTransform: 'none' }}
                  variant="text"
                  color="primary"
                >
                  Register
                </Button>
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="center"
              style={{ marginTop: '10px' }}
              alignItems="flex-end"
            >
              <Grid item md={true} sm={true} xs={true}>
                <div style={{ position: 'relative' }}>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ textTransform: 'none' }}
                    fullWidth
                    onClick={() => login({ user: username, password })}
                  >
                    Login
                  </Button>
                </div>
              </Grid>
            </Grid>
          </div>
        </Paper>
      </Grid>
    </Grid>
  );
}
